import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { get } from 'lodash-es';
import { SrpAd } from 'site-modules/shared/components/native-ad/srp-ad/srp-ad';
import { isRenderedAdUnit } from 'client/utils/ads';
import { SRP_AD } from 'site-modules/shared/components/native-ad/utils/constants';

export class ThankYouAdComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasAdRendered: true,
    };
  }

  hideEmptyAdContainer = slot => {
    this.setState({ hasAdRendered: isRenderedAdUnit(slot) });
  };

  render() {
    const {
      config: { adsPositions },
    } = this.props;
    const currentAdPosition = get(adsPositions, SRP_AD.AD_NAME);
    return (
      <Fragment>
        {this.state.hasAdRendered && <hr />}
        <Row>
          <Col xs={12} lg={9}>
            <SrpAd position={currentAdPosition} slotRenderEndListener={this.hideEmptyAdContainer} />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

ThankYouAdComponent.propTypes = {
  config: PropTypes.shape({
    adsPosition: PropTypes.shape({
      [SRP_AD.AD_NAME]: PropTypes.string,
    }),
  }),
};

ThankYouAdComponent.defaultProps = {
  config: PropTypes.shape({}),
};
